import { observer } from 'mobx-react';
import styles from './UserPriceListModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../UI/modal/Modal';
import { AdditionalUserModelType } from '../../../../internal';
import { toAmount } from '../../../../utils/methods';

export const UserPriceListModal = observer(
  (props: { model: AdditionalUserModelType }): JSX.Element => {
    const { model } = props;
    const { t } = useTranslation();
    return (
      <Modal
        styles={{
          content: {
            minWidth: '60%',
            maxHeight: 'fit-content',
            borderRadius: '20px',
            padding: '40px',
          },
        }}
        model={model.modal}
      >
        <span className={styles.Header}>
          {t('basic:user_addition_price_list')}
        </span>
        <div className={styles.Description}>
          <span>{t('basic:price_list_addition_user_targeting')}</span>
          <span>{t('basic:price_list_addition_user_buying_description')}</span>
        </div>
        <table className={styles.Table}>
          <thead>
            <tr>
              <th>{t('basic:number_of_users')}</th>
              <th>{t('basic:price_per_user')}</th>
            </tr>
          </thead>
          <tbody>
            {model.pricesArray.map((item: any) => (
              <tr key={item}>
                <td>
                  {t('basic:from')} {item.from} {t('basic:to')} {item.to}
                </td>
                <td>
                  {toAmount(item?.price, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 17,
                  })}{' '}
                  RSD
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    );
  }
);
